import { inject, Injectable } from '@angular/core';
import { ApiV3ServiceAddVoucherGet$Params } from '@api-gen/fn/coupon/api-v-3-service-add-voucher-get';
import { AddVoucherResponseApiFrom } from '@api-gen/models/add-voucher-response-api-from';
import { ApiFromCouponService } from '@api-gen/services/api-from-coupon.service';
import { ErrorResponse } from '@api/models';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { startWithErrors } from '@core/operators/start-with-errors';
import { startWithLoading } from '@core/operators/start-with-loading';
import { StartWithUnit } from '@core/operators/start-with-unit';
import { CustomRxState } from '@core/state/rx.state';
import { UserState } from '@core/state/user.state';
import { SnackBarService } from '@shared/components/snack-bar/snack-bar.service';
import { Observable } from 'rxjs';


export interface ICouponState {
    loading: Record<StartWithUnit, boolean>;
    errors: Record<StartWithUnit, ErrorResponse>;
}

@Injectable()
export class CouponState extends CustomRxState<ICouponState> {
    readonly #apiFromCouponService: ApiFromCouponService = inject(ApiFromCouponService);
    readonly #userState: UserState = inject(UserState);
    readonly #snackBarService: SnackBarService = inject(SnackBarService);

    public readonly loading$: Observable<Record<StartWithUnit, boolean>> = this.select('loading');
    public readonly errors$: Observable<Record<StartWithUnit, ErrorResponse>> = this.select('errors');

    constructor() {
        super();

        this.setDefaultState();
    }

    public applyCoupon(input: ApiV3ServiceAddVoucherGet$Params): void {
        this.set({
            errors: null,
        });

        this.hold(
            this.#apiFromCouponService
                .apiV3ServiceAddVoucherGet(input)
                .pipe(startWithLoading(this, StartWithUnit.ApplyCoupon), startWithErrors(this, StartWithUnit.ApplyCoupon)),
            (response: AddVoucherResponseApiFrom) => {
                this.#userState.requestBalance();
                this.#snackBarService.open({
                    text: marker(response.message),
                });
            },
        );
    }

    private setDefaultState(): void {
        this.set({
            loading: null,
            errors: null,
        });
    }
}
